(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ContactSearch', ContactSearch);

  ContactSearch.$inject = ['$resource', 'API_URI'];

  function ContactSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/contacts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
